import { ProductSummary } from './types';

export interface CatalogueEntry extends ProductSummary {
  requiredEntitlement: string;
}

export const productCatalogue: CatalogueEntry[] = [
  {
    id: 'audit',
    name: 'Edinshall Audit',
    requiredEntitlement: 'PlatformAccess',
    status: 'Active',
    features: ['audit-management', 'tenant-dashboard'],
    deepLinks: {
      launch: 'https://tenant.sharepoint.com/sites/edinshall-audit',
      documentation: '/docs?path=docs/documentation/developers/architecture-guide.md',
      adminGuide: '/docs?path=docs/documentation/admins/operations-guide.md',
      support: '/support'
    }
  }
];

export const productsForEntitlements = (entitlements: string[]): ProductSummary[] =>
  productCatalogue.filter((product) => entitlements.includes(product.requiredEntitlement));
